import error404 from '@/views/error-404/error-404.vue'

export default [
  {
    path: '*',
    name: 'error404',
    component: error404
  }
]
